/* Lipscore-tilpasninger (OKH Media)

   Kjorer en enkel tick() med jevne mellomrom i et tidsvindu etter lastetid,
   i tillegg til DOM-overvaking. Grunnen er at bade Shopify-filtre (AJAX) og
   Searchanise bygger om produktlistene etter at siden er ferdig lastet, og da
   er en engangs-init ikke nok.

   tick() gjor fire ting:
   1) SEARCHANISE: injiserer Lipscore-widget i .snize-product-kort, som ligger
      utenfor temaet. Shopify produkt-id finnes i data-original-product-id.
   2) RE-INIT: kaller lipscore.initWidgets() sa lenge det finnes uprosesserte
      widgets (struper til maks ett kall per 600 ms).
   3) KORT: fyller .okh-ls-count med antallet Lipscore returnerer.
   4) PRODUKTSIDE: viser "(X) Omtaler" som lenke ogsa nar produktet har
      stjerner men ingen skrevne omtaler. */
(function () {
  window.okhLipscore = { version: 3, ticks: 0, injected: 0 };

  var PENDING_SEL =
    '.lipscore-rating-small:not([data-ls-product-votes]), .lipscore-rating:not([data-ls-product-votes])';

  var lastInit = 0;
  var INIT_THROTTLE = 600;
  var deadline = 0;
  var timer = null;
  var WINDOW_MS = 30000;

  /* ---------- 1) Searchanise ---------- */
  function injectSearchanise() {
    var cards = document.querySelectorAll('.snize-product[data-original-product-id]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-okh-ls') === '1') continue;

      var id = card.getAttribute('data-original-product-id');
      var priceWrap = card.querySelector('.snize-price-list');
      if (!id || !priceWrap || !priceWrap.parentNode) continue;

      var link = card.querySelector('a.snize-view-link');
      var titleEl = card.querySelector('.snize-title');
      var name = titleEl ? titleEl.textContent.trim() : (link ? link.getAttribute('aria-label') || '' : '');
      var href = link ? link.getAttribute('href') || '' : '';

      var wrap = document.createElement('div');
      wrap.className = 'okh-ls-wrapper okh-ls-wrapper--snize';

      var star = document.createElement('span');
      star.className = 'lipscore-rating-small';
      star.setAttribute('data-ls-product-id', id);
      star.setAttribute('data-ls-product-name', name);
      if (href) star.setAttribute('data-ls-product-url', location.origin + href.split('?')[0]);

      var count = document.createElement('span');
      count.className = 'okh-ls-count';

      wrap.appendChild(star);
      wrap.appendChild(count);
      priceWrap.parentNode.insertBefore(wrap, priceWrap);

      card.setAttribute('data-okh-ls', '1');
      window.okhLipscore.injected++;
    }
  }

  /* ---------- 2) Re-init ---------- */
  function tryInit() {
    if (!document.querySelector(PENDING_SEL)) return;
    var now = Date.now();
    if (now - lastInit < INIT_THROTTLE) return;
    if (window.lipscore && typeof window.lipscore.initWidgets === 'function') {
      lastInit = now;
      try {
        window.lipscore.initWidgets();
      } catch (e) {}
    }
  }

  /* ---------- 3) Antall i kort ---------- */
  function fillCounts() {
    var stars = document.querySelectorAll('.lipscore-rating-small[data-ls-product-votes]');
    for (var i = 0; i < stars.length; i++) {
      var star = stars[i];
      var votes = star.getAttribute('data-ls-product-votes');
      var wrap = star.parentElement;
      var countEl = wrap && wrap.querySelector('.okh-ls-count');
      if (countEl && votes && parseInt(votes, 10) > 0 && countEl.textContent === '') {
        countEl.textContent = '(' + votes + ')';
      }
    }
  }

  /* ---------- 4) "(X) Omtaler" pa produktside ---------- */
  function fixRatings() {
    var ratings = document.querySelectorAll('.lipscore-rating');
    for (var i = 0; i < ratings.length; i++) {
      var rating = ratings[i];
      var link = rating.querySelector('.lipscore-rating-review-link');
      if (!link || link.getAttribute('data-okh-done') === '1') continue;

      var count = link.querySelector('.lipscore-rating-review-count');
      if (!count) continue;

      if (count.textContent.trim() === '') {
        var votesEl = rating.querySelector('.lipscore-rating-votes');
        var votes = votesEl ? votesEl.textContent.trim() : '';
        if (!votes || parseInt(votes, 10) <= 0) continue;
        count.textContent = votes;
      }

      link.classList.remove('lipscore-hidden');
      link.setAttribute('data-okh-done', '1');
    }
  }

  function tick() {
    window.okhLipscore.ticks++;
    injectSearchanise();
    tryInit();
    fillCounts();
    fixRatings();
  }

  function extend() {
    deadline = Date.now() + WINDOW_MS;
    if (timer) return;
    timer = setInterval(function () {
      tick();
      if (Date.now() > deadline) {
        clearInterval(timer);
        timer = null;
      }
    }, 500);
  }

  try {
    new MutationObserver(extend).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'data-ls-product-votes']
    });
  } catch (e) {}

  tick();
  extend();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      tick();
      extend();
    });
  }
  window.addEventListener('load', function () {
    tick();
    extend();
  });
})();